export default __webpack_public_path__ + "static/media/Windy1.753b829a.jpg";